import { createContext } from 'react'

export const PulseScopeContext = createContext(false)
